import update from 'react-addons-update';

export class ChangePasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.state = {data: {}};
    }
	componentWillUnmount () {
		this.xhr && this.xhr.abort();
	}
	bindState(property) {
        return (event) => { 
            this.setState({
                data: update(this.state.data, {[property]: {$set: event.target.value}})
            }); 
        };
	}
	renderErrors(errors) {
		return errors ?
			<div className="text-danger">
				<ul>
                    { Array.isArray(errors) ? errors.map(err => <li>{ err }</li>) : <li>{errors}</li> }
				</ul>
			</div>
			: null;
	}
	onSubmit (e) {
		e.preventDefault();
		var data = this.state.data;
		this.xhr = $.postJSON('/users/change_password', data).done(() => {
            this.setState({success: true});
		}).fail((xhr, textStatus, errorThrown) => {
			if (xhr.status === 400) {
				this.setState(xhr.responseJSON)
			} else {
				this.setState({errors: {'_overall_': 'Operation failed.'}})
			}
		}).always(() => this.xhr = null);
	}
    render() {
        return (
            <div>
                { this.state.success ? <p style={{ marginTop: 20 }}>Your password has been saved successfully.</p> : null }
                <div style={{display: !this.state.success ? 'block' : 'none' }}>
                    {this.renderErrors(this.state.errors && this.state.errors._overall_)}
                    <form action="" method="POST" onSubmit={this.onSubmit}>
                        <div className="form-group">
                            <label htmlFor="current_password">Current password</label>
                            <input type="password" className="form-control" id="current_password" name="current_password" placeholder="Current password" onChange={this.bindState('current_password')} />
                            {this.renderErrors(this.state.errors && this.state.errors.current_password)}
                        </div>
                        <div className="form-group">
                            <label htmlFor="new_password">New password</label>
                            <input type="password" className="form-control" id="new_password" name="new_password" placeholder="New password" onChange={this.bindState('new_password')} />
                            {this.renderErrors(this.state.errors && this.state.errors.new_password)}
                        </div>
                        <div className="form-group">
                            <label htmlFor="new_password_again">New password confirmation</label>
                            <input type="password" className="form-control" id="new_password_again" name="new_password_again" placeholder="Enter the same password as before, for verification." onChange={this.bindState('new_password_again')} />
                            {this.renderErrors(this.state.errors && this.state.errors.new_password_again)}
                        </div>
                        <div className="form-group">
                            <button type="submit" className="btn btn-primary">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
